module.exports = __webpack_public_path__ + "img/nt-no-text.7174d8d8.svg";